import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactService } from '../services/contact.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-contact',
  standalone: false,
  templateUrl: './contact.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent  implements OnInit {
  contactForm: FormGroup;
  captchaQuestion: string = '';
  captchaAnswer: number = 0;
  emailSent: boolean = false;
  contactMapCenter = { lat: 51.938113, lng: 15.505331 };
  contactMapZoom = 19;
  contactPointerLocal = {
    lat: 51.938113,
    lng: 15.505331,
    title: 'Biuro Zgrane Grono',
    subtitle: 'ul. Stary Rynek 1'
  };

  constructor(private fb: FormBuilder, private contactService: ContactService, private snackBar: MatSnackBar) {
    this.contactForm = this.fb.group(
      {
        name: ['', [Validators.required]],
        title: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]],
        phone: ['', []],
        message: ['', [Validators.required]],
        captcha: ['', [Validators.required]],
      },
      { validators: this.emailOrPhoneRequiredValidator }
    );
  }

  ngOnInit(): void {
    this.generateCaptcha();
  }

  generateCaptcha(): void {
    const num1 = Math.floor(Math.random() * 10) + 1; // Random number between 1 and 10
    const num2 = Math.floor(Math.random() * 10) + 1; // Random number between 1 and 10
    this.captchaQuestion = `Jaki jest wynik działania: ${num1} + ${num2}?`;
    this.captchaAnswer = num1 + num2;
  }

  emailOrPhoneRequiredValidator(group: AbstractControl): { [key: string]: boolean } | null {
    const email = group.get('email')?.value;
    const phone = group.get('phone')?.value;

    if (!email && !phone) {
      return { emailOrPhoneRequired: true };
    }
    return null;
  }

  onSubmit(): void {
    if (this.contactForm.valid) {
      const captchaInput = this.contactForm.get('captcha')?.value;
      if (parseInt(captchaInput, 10) !== this.captchaAnswer) {
        alert('Kod zabezpieczeństwa jest nieprawidłowy. Spróbuj ponownie.');
        this.generateCaptcha(); // Generate a new CAPTCHA
        this.contactForm.get('captcha')?.setErrors({ wrongCaptcha: true });
        return;
      }

      this.contactService.sendPartnerContactForm(this.contactForm.value).subscribe({
        next: () => {
          this.snackBar.open('Formularz kontaktowy został wysłany pomyślnie!', 'Zamknij', {
            duration: 29000,
            panelClass: ['success-snackbar'],
            horizontalPosition: 'center', // Center horizontally
            verticalPosition: 'bottom',
          });

          this.emailSent = true;
          this.contactForm.reset();
          this.generateCaptcha(); // Reset CAPTCHA after successful submission
        },
        error: (error) => {
          this.snackBar.open('Wystąpił błąd podczas wysyłania formularza. Spróbuj ponownie później.', 'Zamknij', {
            duration: 29000,
            panelClass: ['error-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          });
        }
      });
    } else {
      this.snackBar.open('Formularz jest nieprawidłowy. Sprawdź wprowadzone dane.', 'Zamknij', {
        duration: 29000,
        panelClass: ['error-snackbar'],
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
      });
    }
  }

  sendNewEmail(): void {
    this.emailSent = false;
    this.contactForm.reset();
    this.generateCaptcha();
  }
}
